import { FaClock, FaMapMarker } from "react-icons/fa"
import eventImg from "../assets/meeting-business-936059_1280.jpg"
import kinam_training from '../assets/_DSC9545.jpg'
import karibe_training from "../assets/_DSC2145.jpg"
import trainingEvent1 from "../assets/FullSizeRender.jpg"
import { useEffect, useState } from "react"

const images = [eventImg, eventImg, kinam_training, karibe_training, trainingEvent1]
const EventComponent = ({ event, index }) => {


    useEffect(() => {
        window.addEventListener('focusin', onFocusIn)
        window.addEventListener(`blur`, onBlurIn)
    }, [])

    const onFocusIn = () => {
        console.log('on focus running...')
    }


    const onBlurIn = () => {
        console.log(`on blur running...`)
    }

    return (
        <>
            <section className={`animate__animated animate__fadeInLeft animate__delay-1s mb-[4rem] mt-2 border-b py-2 px-4`}>
                <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4 ">
                    <div
                        style={{
                            backgroundImage: `url(${images[index]})`,
                            width: "100%",
                            height: "300px",
                            backgroundAttachment: "scroll",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            zIndex: "1",
                        }}
                        className="w-[100%]  h-72 bg-gray-50 "
                    >
                        <div
                            className={`text-center absolute py-6 px-6 z-[11] bg-orange-600 text-white`}
                        >
                            <h1>{event?.month}</h1>
                            <p className="font-bold text-3xl">{event?.day}</p>
                        </div>
                    </div>

                    <div className="w-[100%] py-2 px-4">
                        <h1 className="text-3xl font-bold py-1">{event?.title}</h1>
                        <div className="flex justify-start align-middle items-center gap-4 mb-3">
                            <p className="flex justify-start align-middle items-center gap-2">
                                <FaClock size={16} className="text-orange-500" />
                                <span className="text-[14px]">{event?.time}</span>
                            </p>
                            <p className="flex justify-start align-middle items-center gap-2">
                                <FaMapMarker className="text-orange-500" size={16} />
                                <span className="text-[14px]">{event?.location}</span>
                            </p>
                        </div>

                        <p className="text-[16px] text-justify mb-2">
                            {event?.desc}.
                        </p>
                        {/* 
                        <p className="text-[16px] text-justify ">
                            Lorem ipsum lorem dolor ele tele eme vele dolore Lorem ipsum lorem
                            dolor ele tele eme vele doloreLorem ipsum lorem dolor ele tele eme
                            vele doloreLorem ipsum lorem dolor ele tele eme vele doloreLorem
                            ipsum lorem dolor ele tele.
                        </p> */}
                    </div>
                </div>
            </section>
        </>
    )
}

export default EventComponent